import Logo from "@/components/Logo";

// Aperçu décoratif de l'espace de travail, affiché pendant l'onboarding.
export default function AppPreview() {
  return (
    <div className="onb-preview" aria-hidden="true">
      <div className="onb-preview-bar"><Logo /><div className="sk w-40" style={{ marginLeft: "auto", width: 90 }} /></div>
      <div className="onb-preview-grid">
        <div className="onb-preview-side">
          {[70, 55, 85, 40, 70, 55].map((w, i) => <div key={i} className={`sk w-${w}`} />)}
        </div>
        <div className="onb-preview-main">
          <div className="sk tall w-40" />
          <div className="onb-preview-cards">
            {[0, 1, 2].map(i => (
              <div key={i} className="onb-preview-card"><div className="sk w-55" /><div className="sk tall w-70" /></div>
            ))}
          </div>
          <div className="onb-preview-chart">
            {[34, 48, 40, 62, 55, 74, 68, 86, 78, 94].map((h, i) => <i key={i} style={{ height: `${h}%` }} />)}
          </div>
          <div className="onb-preview-rows">
            {[0, 1, 2].map(i => (
              <div key={i} className="onb-preview-row"><span /><div className="sk w-70" /><div className="sk w-85" /></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
